// extracted by mini-css-extract-plugin
module.exports = {"form-structure-divider":"style_form-structure-divider__y3X_V"};